<template>
  <div>
    <form @submit.prevent="validateBeforeSubmit()">
      <v-card-title>
        <v-layout justify-center row wrap>
          <v-flex xs10>
            <v-layout row justify-center wrap>
              <v-flex xs12 pa-2>
                <v-autocomplete
                  v-model="form.sub_outlet_id"
                  :items="staffMemberSubOutlet"
                  :label="$t('Outlet')"
                  box
                  hide-details
                  background-color="gray"
                  :error="errors.has('Outlet')"
                  data-vv-name="Outlet"
                  :menu-props="{ transition: 'slide-y-transition' }"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-title>

      <v-card-actions>
        <v-layout column>
          <v-layout justify-end ma-2>
            <v-btn type="submit" color="success" :loading="btnUpdateLoading">
              <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
              {{ $t('Switch') }}
            </v-btn>
          </v-layout>
        </v-layout>
      </v-card-actions>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {
      form: {
        sub_outlet_id: 0
      },
      btnUpdateLoading: false
    }
  },

  computed: {
    ...mapGetters({
      authUserData: 'auth/getAuthUserData',
      staffMemberSubOutlet: 'staff/getStaffMemberSubOutlet'
    })
  },

  mounted() {
    this.form.sub_outlet_id = this.authUserData.current_outlet_id_fk

    this.fetchStaffMemberSubOutlet()
  },

  methods: {
    ...mapActions({
      setErrorsList: 'errors/setErrorsList',
      fetchStaffMemberSubOutlet: 'staff/fetchStaffMemberSubOutlet',
      switchStaffMemberOutlet: 'staff/switchStaffMemberOutlet'
    }),

    validateBeforeSubmit() {
      this.$validator
        .validateAll()
        .then(() => {
          if (!this.errors.any()) {
            this.btnUpdateLoading = true
            let payload = this.form.sub_outlet_id

            this.switchStaffMemberOutlet(payload)
              .then(() => {
                this.btnUpdateLoading = false
                window.location.reload()
              })
              .catch(() => {
                this.btnUpdateLoading = false
              })
          }
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>

<style scoped />
